import { dispatchEvent } from "../shared/events";

import "./app.scss";
import "./upsells.scss";
import "../search/export_results_button/exportResultsButton.scss";
import "../features/upgradeNowBanner.scss";

class AppController {
  constructor($meta, $notifier, $limits, $window, UserService, $resourceManager, Modal, $tokenCatcher, $location, $timeout) {
    this.meta = $meta;
    this.$notifier = $notifier;
    this.$limits = $limits;
    this.$window = $window;
    this.$location = $location;
    this.zuul_url = __ZUUL_URL;
    this.isDevelopment = (typeof __IS_PRODUCTION === 'undefined' || (typeof __IS_PRODUCTION !== 'undefined' && !__IS_PRODUCTION) || (typeof __IS_STAGING != 'undefined' && !!_IS_STAGING));
    this.user = UserService.user;
    this.isFreeUser = UserService.user.isFreeUser;
    this.$resourceManager = $resourceManager;
    this.doShowBug = true;
    this.$tokenCatcher = $tokenCatcher;
    this.Modal = Modal;
    this.$timeout = $timeout;
  }

  $onInit() {
    
    // If user is locked, force user to /search and display locked message.
    if (this.user && !this.isFreeUser && this.user.locked) {
      this.$state.target('home');
    }

    if (this.user.coupon && this.$location.search().coupon) {
      this.$timeout(() => dispatchEvent('clickedUnlock'), 1000);
    }

    if (this.$tokenCatcher.suspended) {
      this.Modal.new({
        component: 'suspendedAccountModal',
        dismissable: false
      })
    }

  }

  goToSignUp() {
    this.$location.removeParams("offer");
    dispatchEvent('clickedUnlock');
  }

  goToAccountSubscription() {
    this.$window.location.href = `${__ZUUL_URL}/account/subscription`
  }

}


AppController.$inject = ['$meta', '$notifier', '$limits', '$window', 'UserService', '$resourceManager', 'Modal', '$tokenCatcher', '$location', '$timeout'];

export const app = {
  bindings: { user: '<' },
  controller: AppController,
  template: require('./app.html')
};